<p-fieldset [legend]="'msg.workspace.settings.metadata.title' | translate">
  <selfai-platform-workflow-settings-metadata
    [workflow]="dialogService.data"
    (submitEvent)="editMetadata($event)"
  ></selfai-platform-workflow-settings-metadata>
</p-fieldset>
<p-fieldset [legend]="'msg.workspace.settings.presets.title' | translate" [styleClass]="'mt-4'">
  <selfai-platform-workflow-settings-presets
    [presets]="workflowPresetsDomainService.workflowPresets$ | async"
    [workflowId]="workflowId"
    [currentPresetId]="(currentPreset$ | async)?.id"
    (submitEvent)="setPreset($event)"
  ></selfai-platform-workflow-settings-presets>
</p-fieldset>
<p-fieldset [legend]="'msg.workspace.settings.schedules.title' | translate" [styleClass]="'mt-4'">
  <selfai-platform-workflow-settings-schedules
    [presets]="workflowPresetsDomainService.workflowPresets$ | async"
    [schedules]="workflowSettingsSchedulesDomainService.workflowSettingsSchedules$ | async"
    [workflowId]="workflowId"
    (addSchedule)="onAddSchedule($event)"
    (editSchedule)="onEditSchedule($event)"
    (deleteSchedule)="onDeleteSchedule($event)"
  ></selfai-platform-workflow-settings-schedules>
</p-fieldset>
